import { useCallback } from 'react'

import { useGetSlackIntegrationConfigPresenter } from '@webapp/platform/integrations/features/get-slack-integration-config'

export const useSlackIntegrationSection = () => {
  const { isIntegrated, oauthUrl, isLoading, error } =
    useGetSlackIntegrationConfigPresenter()

  const handleConnect = useCallback(() => {
    globalThis.location.href = oauthUrl
  }, [oauthUrl])

  return {
    isIntegrated,
    handleConnect,
    isLoading,
    error,
  }
}
